module.exports = __webpack_public_path__ + "img/icon-01.f64d3bb6.png";